import { render, staticRenderFns } from "./tabloid.vue?vue&type=template&id=5d43369c&scoped=true&"
import script from "./tabloid.vue?vue&type=script&lang=js&"
export * from "./tabloid.vue?vue&type=script&lang=js&"
import style0 from "./tabloid.vue?vue&type=style&index=0&id=5d43369c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d43369c",
  null
  
)

export default component.exports